// src/components/ui/RefreshButton.tsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/pro-regular-svg-icons";
import BaseButton from "../../../../BaseButton/BaseButton";
import { getFontAwesomeIcon } from "../../../../../../utils";

interface RefreshButtonProps {
	loading: boolean;
	onClick: () => void;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({ loading, onClick }) => (
	<BaseButton
		text="Refresh"
		bgColor="bg-white"
		fontColor="text-primary"
		buttonSize="h-26px"
		shape="rounded-full"
		icon={
			<span className="text-primary rounded text-xs p-0.5">
				{loading ? (
					<div className="fa-spin min-w-4 max-w-4">
						<FontAwesomeIcon icon={faSync} />
					</div>
				) : (
					getFontAwesomeIcon("arrowsRotate", "solid")
				)}
			</span>
		}
		iconBreakpoint="max-sm:pr-0"
		additionalClasses="hover:bg-supply-blue-50 border-1 border-primary text-nowrap max-sm:size-8 max-sm:justify-center text-14px px-3 py-1"
		as="button"
		textBreakpoint="max-sm:hidden"
		onClick={onClick}
		fontFamily="font-omnes-medium"
		iconClasses="pr-2"
	/>
);

export default RefreshButton;
